import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import {Link} from 'react-router-dom';
import FullscreenToggle from '../components/FullscreenToggle'

export default function Navbar2() {
  const [expanded, setExpanded] = useState(false);
  const fullscreen = FullscreenToggle();

  return (
    <Navbar 
    expand="lg" 
    fixed="top" 
    className="bg-body-tertiary"
    expanded={expanded}
    onToggle={(val) => setExpanded(val)}
    >
        
      <Container className='d-flex justify-content-between align-items-center'>
        <Navbar.Brand> <Link to="/" className="text-decoration-none text-reset gorditas-regular">Little Kai</Link></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className='justify-content-end'/>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            
            <NavDropdown title="Soundboard" id="basic-nav-dropdown">
                <NavDropdown.Item 
                  as={Link} 
                  to="/soundboard-animal" 
                  className='d-flex justify-content-between align-items-center pb-1 pt-1' 
                  onClick={() => setExpanded(false)}> 
                  <span>Animal</span> 
                  <img src='./images/livestock.png' alt='Livestock' height="40px" width="40px" />
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item 
                  as={Link} 
                  to="/soundboard-fruit" 
                  className='d-flex justify-content-between align-items-center pb-1 pt-1' 
                  onClick={() => setExpanded(false)}> 
                  <span>Fruit</span> 
                  <img src='./images/fruit.png' alt='Fruit' height="40px" width="40px" />
                </NavDropdown.Item>
            </NavDropdown>


            <NavDropdown title="Flipbook" id="basic-nav-dropdown">
              <NavDropdown.Item 
                  as={Link} 
                  to="/flipbook-dogs" 
                  className='d-flex justify-content-between align-items-center pb-1 pt-1' 
                  onClick={() => setExpanded(false)}> 
                  <span>Dogs</span> 
                  <img src='./images/dog-static.png' alt='Dogs' height="40px" width="40px" />
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item 
                  as={Link} 
                  to="/flipbook-cats" 
                  className='d-flex justify-content-between align-items-center pb-1 pt-1' 
                  onClick={() => setExpanded(false)}> 
                  <span>Cats</span> 
                  <img src='./images/cat-static.png' alt='Cat' height="40px" width="40px" />
                </NavDropdown.Item>
            </NavDropdown>


            <NavDropdown title="More" id="basic-nav-dropdown">
                <NavDropdown.Item 
                  as={Link} 
                  to="/about" 
                  className='d-flex justify-content-between align-items-center pb-1 pt-1' 
                  onClick={() => setExpanded(false)}> 
                  <span>About</span> 
                  <img src='./images/book.png' alt='Book' height="40px" width="40px" />
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item 
                  as={Link} 
                  to="/reference" 
                  className='d-flex justify-content-between align-items-center pb-1 pt-1' 
                  onClick={() => setExpanded(false)}> 
                  <span>Reference</span> 
                  <img src='./images/refer.png' alt='Refer Pic' height="40px" width="40px" />
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  className='d-flex justify-content-between align-items-center pb-1 pt-1' 
                  onClick={() => 
                   
                  setExpanded(false)}> 
                  <span><FullscreenToggle /></span> 
                  
                  <img src='./images/fullscreen.png' alt='Fruit' height="40px" width="40px" />
                </NavDropdown.Item>
            </NavDropdown>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
